var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-badge',{staticClass:"add-section",attrs:{"pill":"","variant":"primary","title":"Ajouter une section"},on:{"click":function($event){return _vm.addSection()}}},[_c('i',{staticClass:"mdi mdi-plus"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }